import React, { useState } from "react";
import { Editor } from "react-draft-wysiwyg";
import { convertToRaw, EditorState } from "draft-js";
import { stateToHTML } from "draft-js-export-html";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import Button from "./Button";

export default function HtmlEditor() {
  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const [htmlContent, setHtmlContent] = useState("");

  const onEditorStateChange = (newState) => {
    setEditorState(newState);
    const content = newState.getCurrentContent();
    const html = stateToHTML(content);
    setHtmlContent(html); // Update the HTML content state
  };

  return (
    <div style={{ width: "100%" }}>
      <Editor
        editorState={editorState}
        wrapperClassName="demo-wrapper"
        editorClassName="demo-editor"
        onEditorStateChange={onEditorStateChange}
      />
      <Button>Save and Publish</Button>

      <h3>Generated HTML:</h3>
      <div
        style={{
          border: "1px solid #ccc",
          padding: "10px",
          marginTop: "20px",
          backgroundColor: "#f9f9f9",
        }}
      >
        <pre>{htmlContent}</pre>
      </div>
    </div>
  );
}
